import React from 'react'

export default function VideoEditing() {
  return (
   <div>
    <div class="container mx-auto p-4 mt-12">
  
  <div class="hidden lg:flex lg:flex-row lg:space-x-4">
    <div class="w-1/3 bg-blue-500 p-6">Desktop/Laptop Column 1</div>
    <div class="w-1/3 bg-green-500 p-6">Desktop/Laptop Column 2</div>
    <div class="w-1/3 bg-red-500 p-6">Desktop/Laptop Column 3</div>
  </div>

 
  <div class="hidden md:flex md:flex-row md:space-x-4 lg:hidden">
    <div class="w-1/2 bg-yellow-500 p-6">Tablet Column 1</div>
    <div class="w-1/2 bg-purple-500 p-6">Tablet Column 2</div>
  </div>


  <div class="flex flex-col space-y-4 md:hidden">
    <div class="bg-gray-500 p-6">Mobile Row 1</div>
    <div class="bg-pink-500 p-6">Mobile Row 2</div>
    <div class="bg-indigo-500 p-6">Mobile Row 3</div>
  </div>
</div>

   </div>
  )
}
